module.exports = __webpack_public_path__ + "media/images/sold-out.it-8f84d8331a5c803d8804f53d48657e3f.png";